// extracted by css-extract-rspack-plugin
export default {"header":"hdZoH","logs":"Ta2R8","visualization":"U2UA7","results":"kiwQU","tableHeader":"hhHFX","tableCell":"Z0ckH","loading":"CFCke","error":"BkaZA","traceback":"UxQYd"};